import { observer } from 'mobx-react-lite';
import {
    Filter_FilterWordText,
    Filter_FilterExcelText,
    Filter_FilterPDFText,
    Filter_FilterPowerPointText,
    Filter_FilterAllText,
} from './FilePickerFilterView.locstring.json';
import loc from 'owa-localize';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import { ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import AttachmentItemsFilterBy from 'owa-service/lib/contract/AttachmentItemsFilterBy';
import * as React from 'react';

import { ControlIcons } from 'owa-control-icons';

export interface FilePickerFilterProps {
    filterOptions: AttachmentItemsFilterBy[];
    selectedFilterOption: AttachmentItemsFilterBy;
    getTargetElement: HTMLElement;
    onFilterOptionClicked: (selectedFilter: AttachmentItemsFilterBy) => void;
    onFilterMenuDismissed: () => void;
}

// This component is responsible for showing filter menu options in the File Picker.
export default observer(function FilePickerFilterView(props: FilePickerFilterProps) {
    const getFilterOptionsItems = (): IContextualMenuItem[] => {
        return props.filterOptions.map(filterOption => createFilterOptionItem(filterOption));
    };
    const createFilterOptionItem = (filterBy: AttachmentItemsFilterBy): IContextualMenuItem => {
        switch (filterBy) {
            case AttachmentItemsFilterBy.WordFiles:
                return getItem(filterBy, loc(Filter_FilterWordText));
            case AttachmentItemsFilterBy.ExcelFiles:
                return getItem(filterBy, loc(Filter_FilterExcelText));
            case AttachmentItemsFilterBy.PDFFiles:
                return getItem(filterBy, loc(Filter_FilterPDFText));
            case AttachmentItemsFilterBy.PowerPointFiles:
                return getItem(filterBy, loc(Filter_FilterPowerPointText));
            case AttachmentItemsFilterBy.None:
                return getItem(filterBy, loc(Filter_FilterAllText));
            default:
                throw new Error(
                    'This AttachmentItemsFilterBy type is not being correctly handled in the createFilterOptionItem() method:' +
                        filterBy
                );
        }
    };
    const getItem = (
        filterItem: AttachmentItemsFilterBy,
        filterName: string
    ): IContextualMenuItem => {
        return {
            key: filterItem.toString(),
            icon: props.selectedFilterOption === filterItem ? ControlIcons.Accept : '',
            name: filterName,
            onClick: () => {
                props.onFilterOptionClicked(filterItem);
            },
        };
    };
    return (
        <ContextualMenu
            shouldFocusOnMount={true}
            directionalHint={DirectionalHint.bottomRightEdge}
            target={props.getTargetElement}
            onDismiss={props.onFilterMenuDismissed}
            items={getFilterOptionsItems()}
        />
    );
});
